import { queryOptions } from '@tanstack/react-query';
import { dashboardService } from './dashboard.service';
import type { DashboardQueryParams, PaginatedQueryParams } from './dashboard.service';
import { dashboardKeys } from './dashboard.keys';

export const dashboardQueries = {
    kpis: (params: DashboardQueryParams) => queryOptions({
        queryKey: dashboardKeys.kpis(params),
        queryFn: () => dashboardService.getKpis(params),
        refetchInterval: 30000, // 30 seconds polling
    }),
    
    analytics: (params: DashboardQueryParams) => queryOptions({
        queryKey: dashboardKeys.analytics(params),
        queryFn: () => dashboardService.getAnalytics(params),
        refetchInterval: 30000,
    }),
    
    merchants: (params: PaginatedQueryParams) => queryOptions({
        queryKey: dashboardKeys.merchants(params),
        queryFn: () => dashboardService.getMerchants(params),
        refetchInterval: 30000,
    }),
    
    transactions: (params: PaginatedQueryParams) => queryOptions({
        queryKey: dashboardKeys.transactions(params),
        queryFn: () => dashboardService.getTransactions(params),
        refetchInterval: 30000,
    }),
    
    invoices: (params: PaginatedQueryParams) => queryOptions({
        queryKey: dashboardKeys.invoices(params),
        queryFn: () => dashboardService.getInvoices(params),
        refetchInterval: 30000,
    }),
    
    renewals: (params: PaginatedQueryParams) => queryOptions({
        queryKey: dashboardKeys.renewals(params),
        queryFn: () => dashboardService.getRenewals(params),
        refetchInterval: 30000,
    }),
    
    ads: (params: DashboardQueryParams) => queryOptions({
        queryKey: dashboardKeys.ads(params),
        queryFn: () => dashboardService.getAds(params),
        refetchInterval: 30000,
    }),
};
